import { render, staticRenderFns } from "./DialogoPedidosCompra.vue?vue&type=template&id=3e6eda18&scoped=true&"
import script from "./DialogoPedidosCompra.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogoPedidosCompra.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6eda18",
  null
  
)

export default component.exports